module.exports = __webpack_public_path__ + "img/SEJ_Eventos_agregar a me interesa.4fc7674a.svg";